<script>
	import listBase from '@_system/components/base/list.vue'
	import goodstypetree from './goodstypetree/tree.vue'
	import totalIndex from './total/index.vue'
	export default {
		extends: listBase,
		name: 'goodsrevenueinfoIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-button size="mini" type="success" onClick={this.totalShow}>所有分类</el-button>		
			]
			this.$slots.aside = [ <goodstypetree ref = "goodstypetree" key = {this.goodstypetreeKey} onSelect = {this.goodstypetreeChange} onFlashtree={this.flashtree} /> ],
			this.$slots.plug = [
				<total-index ref="totalIndex" onFlashtree={this.flashtree}   />,
			]		
			return listBase.render.call(this, h)
		},
		data() {
			return {
				loading: false,
				moduleName: 'goodsrevenueinfo',
				windowName: '商品',
				goodstypetreeKey:Math.random()
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			initList() {
				this.initOption()
			},
			getColumns(){
				return 	[{
						field: 'a',
						title: 'A'
					},
					{
						field: 'b',
						title: 'B'
					}
				]
			},
			getForm(){
				return {
					titleWidth: '80',
					titleAlign: 'center',
					items: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					},{
						itemRender: {
							name: '$buttons',
							children: [{
								props: {
									type: 'submit',
									content: '查询',
									status: 'primary'
								}
							}, {
								props: {
									type: 'reset',
									content: '重置'
								}
							}]
						}
					}],
					span: 4
				}
			},
			beforeCreateGrid(formConfig, columns, gridOptions){
				gridOptions.toolbarConfig =  {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '添加',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					tools: this.tools
				}
			},
			toolbarButtonClickEvent(e){
				this[e.code]()
			},
			add(){
				alert(123)
			},
			goodstypetreeChange(){
				
			},
			totalShow(){
				this.$refs.totalIndex.modal_show()
			},
			flashtree(){
				this.goodstypetreeKey = Math.random()
			}
		},
		components: {
			totalIndex
		}
	}
</script>
